import React from 'react';
import { useParams } from 'react-router-dom';
import FormContents from 'components/atoms/Form/FormContents';
import FormField from 'components/atoms/Form/FormField';
import TextForm from 'components/molecules/TextForm';
import FormSubmitArea from 'components/atoms/Form/FormSubmitArea';
import Button, { PrimaryButton } from 'components/atoms/Button';
import ConfirmModal from 'components/organismos/ConfirmModal';
import ConfirmActionModal, { ActionType } from 'components/organismos/ConfirmActionModal';
import useDiscountTypeAddForm from './hook';
import { useSelector } from 'react-redux';
import { Store } from 'modules/store';

const DiscountTypeAddForm = () => {
  const { discountTypeMstCode } = useParams();
  const {
    formik, confirmModalOpen, contentModalCustom, closeConfirmModal, history,
    confirmModalCustomOpen, closeConfirmModalCustom,
  } = useDiscountTypeAddForm();

  const roleScreen = useSelector((state: Store) => state.auth.roleScreen)

  return (
    <FormContents>
      <p>値引・割引種別を登録します。コード、名称、並び順を入力してください。</p>
      <form onSubmit={formik.handleSubmit}>
        <div>
          <FormField>
            <TextForm
              label="コード"
              name="discountTypeMstCode"
              value={formik.values.discountTypeMstCode}
              onChange={formik.handleChange}
              errorMsg={formik.errors.discountTypeMstCode}
              required={true}
              disable={!!discountTypeMstCode}
            />
          </FormField>
          <FormField>
            <TextForm
              label="名称"
              name="discountTypeMstName"
              value={formik.values.discountTypeMstName}
              onChange={formik.handleChange}
              errorMsg={formik.errors.discountTypeMstName}
              required={true}
            />
          </FormField>

          <FormField>
            <TextForm
              type="number"
              label="並び順"
              min="0"
              name="dispOrder"
              value={formik.values.dispOrder}
              onChange={formik.handleChange}
              errorMsg={formik.errors.dispOrder}
              required={true}
            />
          </FormField>

        </div>

        <FormSubmitArea>
          {
            roleScreen && roleScreen.editable === 1 && (
              <div style={{ marginRight: '12px' }}>
                <Button
                  text={discountTypeMstCode ? '更新' : '値引・割引種別を登録'}
                  onClick={formik.handleSubmit}
                />
              </div>
            )
          }
          <PrimaryButton
            text="戻る"
            onClick={() => {
              history.replace('/discountTypeMst/discountType');
            }}
            ghost={true}
          />
        </FormSubmitArea>
      </form>

      <ConfirmActionModal
        open={confirmModalOpen}
        closeHandler={closeConfirmModal}
        onSubmit={formik.handleSubmit}
        actionType={discountTypeMstCode ? ActionType.UPDATE : ActionType.CREATE}
      />
      <ConfirmModal
        title="確認メッセージ"
        open={confirmModalCustomOpen}
        closeHandler={closeConfirmModalCustom}
        submitText={discountTypeMstCode ? '更新' : '登録'}
        content={contentModalCustom}
        onSubmit={formik.handleSubmit}
      />
    </FormContents>
  );
};

export default DiscountTypeAddForm;
